import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export default async function getRolesAccessibilities(callback) {
	firebaseRef.ref('/kavtek_roles/' + projectCode).on('value', (snapshot) => {
		let rolesParent = snapshot.val();
        let roles = {};

		if (rolesParent) {
			for (let key in rolesParent) {
				roles[key] = rolesParent[key].accessibilities;
			}
		}

        callback(roles);
	});
}
